import React from 'react';
import { LegalSinglePage } from './Legal';

const PrivacyPolicy = () => <LegalSinglePage kind="privacy" />;

export default PrivacyPolicy;
